import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../hooks/useStore';
import { DataViewEditBox, Loading } from '../../../lib/components';
import { FC } from 'react';
import { format } from 'date-fns';
import { DataView } from './shared/view';
import { useCompanyBenefitSettingsData, usePaymentData } from '../../../queries/company';
import { Box } from '@mui/material';

type Props = {
  dialogView?: boolean;
};

export const CompanyHardwareSettings: FC<Props> = observer((props) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const { data: paymentData } = usePaymentData(companyStore.company?.id ?? '');
  const { data: benefitSettingsData, isLoading } = useCompanyBenefitSettingsData(
    companyStore.company?.id ?? ''
  );
  const settingsData = {
    enabled: paymentData?.booked_benefits?.includes('mpp')
  };

  const contractData = {
    main_partner: benefitSettingsData?.mpp?.main_partner ?? '',
    customer_number: benefitSettingsData?.mpp?.customer_number ?? '',
    contract_number: benefitSettingsData?.mpp?.contract_number ?? '',
    contact_name: [
      benefitSettingsData?.mpp?.advisor?.first_name,
      benefitSettingsData?.mpp?.advisor?.last_name
    ]
      .filter(Boolean)
      .join(' '),
    contact_mail: benefitSettingsData?.mpp?.advisor?.contact_mail ?? '',
    contact_number: benefitSettingsData?.mpp?.advisor?.contact_number ?? '',
    contract_start: benefitSettingsData?.mpp?.contract_start
      ? format(new Date(benefitSettingsData?.mpp?.contract_start), 'dd.MM.yyyy')
      : '',
    contract_end: benefitSettingsData?.mpp?.contract_end
      ? format(new Date(benefitSettingsData?.mpp?.contract_end), 'dd.MM.yyyy')
      : '',
    admin_portal: benefitSettingsData?.mpp?.admin_portal ?? ''
  };

  const contract_document = benefitSettingsData?.mpp?.contract_document ?? undefined;

  const renderView = observer(() => (
    <DataView
      hideSettingData={props.dialogView}
      benefit="mpp"
      settingsData={settingsData}
      contractData={contractData}
      contract={contract_document}
    />
  ));

  const renderEdit = () => <></>;

  return isLoading ? (
    <Box className="w-[950px] mt-20">
      <Loading />
    </Box>
  ) : (
    <DataViewEditBox
      title={t('common:MPP')}
      view={renderView}
      edit={renderEdit}
      canEdit={false}
      canSubmit={false}
    />
  );
});
